import { Routes } from '@angular/router';
import { BidlistComponent } from './components/bidlist/bidlist.component';
import { SharedlistsComponent } from './components/sharedlists/sharedlists.component';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { AmbassadorGuard } from '../app/guards/ambassador/ambassador.guard';
import { AuthGuard, LaunchDarklyUserGuard, RoleBasedGuard } from 'remarketing-angular-library';
import { VehicleRoutePaths } from './vehicleRoutePaths';
import { vehicleDetailRefactorGuard } from './guards/vehicle-detail-version.guard';
import { bidlistReactGuard } from './guards/bidlist-react-version.guard';
import { sharedlistReactGuard } from './guards/sharedlist-react-version.guard';

export const vehiclesRoutes: Routes = [
  {
    path: 'vehicles',
    loadComponent: () => import('./components/vehicle-page/vehicle-page.component').then(c => c.VehiclePageComponent),
    canActivate: [
      AgreementsGuard,
      LaunchDarklyUserGuard,
      AuthGuard,
      RoleBasedGuard
    ],
    data : {
      flag: 'bidlistEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    },
    children: [
      {
        // First match wins. Flag off -> this entry does not match and the Angular
        // BidlistComponent below serves the same path, so rollback needs no deploy.
        path: VehicleRoutePaths.BID_LIST,
        loadComponent: () => import('./react-host/react-bidlist-host.component').then(c => c.ReactBidlistHostComponent),
        canMatch: [bidlistReactGuard]
      },
      {
        path: VehicleRoutePaths.BID_LIST,
        component: BidlistComponent
      },
      {
        // First match wins. Flag off -> this entry does not match and SharedlistsComponent
        // below serves the same path unchanged — rollback needs no deploy.
        path: VehicleRoutePaths.SHARED_LISTS,
        loadComponent: () => import('./react-host/react-sharedlist-host.component').then(c => c.ReactSharedlistHostComponent),
        canMatch: [sharedlistReactGuard]
      },
      {
        path: VehicleRoutePaths.SHARED_LISTS,
        component: SharedlistsComponent,
      },
      {
        path: VehicleRoutePaths.IN_SERVICE,
        component: SharedlistsComponent
      },
      {
        path: VehicleRoutePaths.CUSTOM_OFFERS,
        component: SharedlistsComponent
      },
      {
        path: '',
        redirectTo: VehicleRoutePaths.BID_LIST,
        pathMatch: 'full'
      }
    ]
  },
  {
    path: VehicleRoutePaths.CARFAX,
    loadComponent: () => import('./components/carfax-report/carfax-report.component').then(c => c.CarfaxReportComponent),
    canActivate: [AgreementsGuard, AuthGuard, RoleBasedGuard],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  },
  {
    path: VehicleRoutePaths.EMAIL,
    loadComponent: () => import('./components/vdp-email/vdp-email.component').then(c => c.VdpEmailComponent),
    canActivate: [
      AgreementsGuard,
      AmbassadorGuard,
      AuthGuard,
      RoleBasedGuard
    ],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  },
  {
    path: VehicleRoutePaths.MAP,
    loadComponent: () => import('./components/map/map.component').then(c => c.MapComponent),
    canActivate: [AgreementsGuard, AuthGuard, RoleBasedGuard],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  },
    {
    path: VehicleRoutePaths.VIN_OR_AUCTION_ITEM,
    loadComponent: () => import('./refactor/vehicle-detail-refactor/vehicle-detail-refactor.component').then(c => c.VehicleDetailRefactorComponent),
    canMatch: [vehicleDetailRefactorGuard],
    canActivate: [
      AgreementsGuard,
      AmbassadorGuard,
      AuthGuard,
      RoleBasedGuard
    ],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  },
  {
    path: VehicleRoutePaths.VIN_OR_INVENTORY_ITEM,
    loadComponent: () => import('./components/vehicle-detail/vehicle-detail.component').then(c => c.VehicleDetailComponent),
    canActivate: [
      AgreementsGuard,
      AmbassadorGuard,
      AuthGuard,
      RoleBasedGuard
    ],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  },
  {
    path: VehicleRoutePaths.AUTO_VISION_EMAIL,
    loadComponent: () => import('./components/vdp-email/vdp-email.component').then(c => c.VdpEmailComponent),
    canActivate: [
      AgreementsGuard,
      AmbassadorGuard,
      AuthGuard,
      RoleBasedGuard
    ],
    data: {
      flag: { isAutoVision: true },
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  }
];

